"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./Slider.css");
var react_slider_1 = __importDefault(require("react-slider"));
var classnames_1 = __importDefault(require("classnames"));
var Input_1 = require("../../components/Input");
var Row_1 = require("../../components/Row");
var Slider = function (_a) {
  var className = _a.className,
    invert = _a.invert,
    orientation = _a.orientation,
    value = _a.value,
    trackClassName = _a.trackClassName,
    thumbClassName = _a.thumbClassName,
    markClassName = _a.markClassName,
    _b = _a.min,
    min = _b === void 0 ? 0 : _b,
    _c = _a.max,
    max = _c === void 0 ? 100 : _c,
    _d = _a.inputField,
    inputField = _d === void 0 ? "editable" : _d,
    inputError = _a.inputError,
    rowProps = _a.rowProps,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = _a.readOnly,
    readOnly = _f === void 0 ? false : _f,
    onChange = _a.onChange,
    restProps = __rest(_a, ["className", "invert", "orientation", "value", "trackClassName", "thumbClassName", "markClassName", "min", "max", "inputField", "inputError", "rowProps", "disabled", "readOnly", "onChange"]);
  var isRange = value !== undefined && typeof value !== "number";
  if (isRange && (value === null || value === void 0 ? void 0 : value.length) !== 2) {
    throw new Error("Slider value array must have exactly two values.");
  }
  var cn = (0, classnames_1.default)("vsx-slider", (disabled || readOnly) && "vsx-slider-disabled", invert && "vsx-slider-invert", isRange && "vsx-slider-range", className);
  var boundOnChangeRange = function (v1, v2) {
    if (v1 > v2) return;
    if (!onChange) return;
    //@ts-ignore
    onChange([v1, v2]);
  };
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    gap: "medium",
    align: "center",
    className: "vsx-slider-container"
  }, rowProps, {
    children: [inputField !== "none" && isRange && (0, jsx_runtime_1.jsx)(Input_1.Input, {
      min: min,
      max: max,
      type: "number",
      readOnly: inputField === "readonly" || readOnly || disabled,
      className: "vsx-slider-input",
      value: isRange ? value === null || value === void 0 ? void 0 : value.at(0) : value,
      error: inputError,
      disabled: disabled || readOnly,
      // @ts-ignore
      onChange: function (e) {
        return isRange ? boundOnChangeRange(Number(e.currentTarget.value), value[1]) : onChange(Number(e.currentTarget.value));
      }
    }), (0, jsx_runtime_1.jsx)(react_slider_1.default, __assign({
      className: cn,
      trackClassName: (0, classnames_1.default)("vsx-slider-track", trackClassName),
      thumbClassName: (0, classnames_1.default)("vsx-slider-thumb", thumbClassName),
      markClassName: (0, classnames_1.default)("vsx-slider-mark", markClassName),
      disabled: disabled || readOnly,
      invert: invert,
      value: value,
      onChange: onChange,
      min: min,
      max: max
    }, restProps)), inputField !== "none" && (0, jsx_runtime_1.jsx)(Input_1.Input, {
      min: min,
      max: max,
      type: "number",
      readOnly: inputField === "readonly" || readOnly || disabled,
      className: "vsx-slider-input",
      value: isRange ? value === null || value === void 0 ? void 0 : value.at(1) : value,
      error: inputError,
      // @ts-ignore
      onChange: function (e) {
        return isRange ? boundOnChangeRange(value[0], Number(e.currentTarget.value)) : onChange(Number(e.currentTarget.value));
      }
    })]
  }));
};
exports.Slider = Slider;